import { render, staticRenderFns } from "./ServiceApply.vue?vue&type=template&id=57b4923c&scoped=true&"
import script from "./ServiceApply.vue?vue&type=script&lang=js&"
export * from "./ServiceApply.vue?vue&type=script&lang=js&"
import style0 from "./ServiceApply.vue?vue&type=style&index=0&id=57b4923c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b4923c",
  null
  
)

export default component.exports